import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>🐾 The Pet Nanny of Weston</h3>
          <p>Professional, loving pet care in Weston, Florida. Your pets deserve the best care while you're away!</p>
        </div>
        
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>📍 Weston, Florida</p>
          <p><a href="tel:954-560-6839" className="footer-phone">📞 954-560-6839</a></p>
          <p className="footer-phone-note">Call or Text Anytime!</p>
          <p><a href="mailto:thepetnannyofweston@gmail.com" className="footer-email">📧 thepetnannyofweston@gmail.com</a></p>
        </div>
        
        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li>Overnight Boarding</li>
            <li>Drop-in Visits</li>
            <li>Dog Walks</li>
            <li>Medication Administration</li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Hours</h4>
          <p>Available 7 Days a Week</p>
          <p>Drop-off & Pick-up: 8am - 8pm</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} The Pet Nanny of Weston. All rights reserved.</p>
        <p>Made with ❤️ for your furry friends</p>
      </div>
    </footer>
  );
};

export default Footer;
